import styles from "./Product.module.scss"

import React, { useState } from "react"
import { GrClose } from "react-icons/gr"
import { useParams } from "react-router-dom"

import { WOWNET_CONTENT } from "@shared/constants"

import classNames from "classnames"
import {useIsMiniPlayerEnabled} from "../../contexts/miniPlayer";

export default function Product() {
  const { streamerName } = useParams<{ streamerName?: string }>()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const isMiniPlayerEnabled = useIsMiniPlayerEnabled()

  if (isMiniPlayerEnabled)  {
    return null
  }

  return (
    <article className={classNames("viewB", { max: isOpen })}>
      <a
        href="#!"
        className="btn"
        title="보기"
        onClick={(e) => {
          e.preventDefault()

          setIsOpen(!isOpen)
        }}
      >
        보기
      </a>
      <div className={classNames("inner", styles.inner)}>
        <div className="iframeB">
          <iframe
            src={`${WOWNET_CONTENT.footerMaxBox}?analid=${streamerName}`}
            className={styles.size}
            title="하단 와우넷"
          />
          <GrClose
            title="닫기"
            className={styles.close}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          />
        </div>
      </div>
    </article>
  )
}
